import { ToolPageShell } from '@/shared/seo'
import { NumeraciyaStranicForm } from './NumeraciyaStranicForm'

export function NumeraciyaStranicPage() {
  return (
    <ToolPageShell utilityKey="numeraciyaStranic">
      <NumeraciyaStranicForm />
    </ToolPageShell>
  )
}
